angular.module('env.data.repos.workflow', [])

    .service("workflowRepository", function ($q, rest) {
        var _this = this;

        var stepType = "StepModel";
        var actionType = "ActionModel";

        //region Steps

        var stepsCache;
        /**
         * Get list of steps
         * @returns {!Promise.<RepresentationModel[]>} promise of steps collection
         */
        _this.getSteps = function () {
            if (stepsCache) {
                return $q.when(stepsCache.slice(0));
            }

            return rest
                .map("workflow", "steps")
                .willReturn(stepType)
                .get()
                .then(function (steps) {
                    if (steps) {
                        stepsCache = steps.slice(0);
                    }
                    return steps;
                });
        };

        /**
         * Get step by step code
         * @param {string} stepCode step code
         * @returns {!Promise.<RepresentationModel>} promise of step model
         */
        _this.getStepByCode = function (stepCode) {
            if (stepsCache) {
                var step = _.find(stepsCache, function (step) {
                    return step.$model.code == stepCode;
                });
                if (step) {
                    return $q.when(step);
                }
            }

            return rest.map("workflow", "steps").willReturn(stepType).get({params: {code: stepCode}});
        };

        /**
         * Get step by id
         * @param {string} id id of the step model
         * @returns {!Promise.<RepresentationModel>} promise of step model
         */
        _this.getStepById = function (id) {
            if (stepsCache) {
                var step = _.find(stepsCache, function (step) {
                    return step.getId() == id;
                });
                if (step) {
                    return $q.when(step);
                }
            }

            return rest.map("workflow", "steps").willReturn(stepType, id).get({params: {id: id}});
        };

        /**
         * Save step
         * @param {RepresentationModel} step Step Model
         * @returns {!Promise.<RepresentationModel>} promise of Step Model save
         */
        _this.saveStep = function (step) {
            return rest.map("workflow", "steps").save(step);
        };

        /**
         * Get step statistics
         * @returns {!Promise.<Object[]>} promise of step statistics
         */
        _this.getStepStatistics = function () {
            return rest.map("workflow", "steps", "statistics").get();
        };

        //endregion

        //region Actions

        // Actions for steps cache
        var stepsToActions = {};
        /**
         * Get list of actions by step name
         * @param {string} stepCode step name
         * @returns {!Promise.<RepresentationModel[]>} promise of actions collection
         */
        _this.getActionsForStep = function (stepCode) {
            if (stepsToActions[stepCode]) {
                return $q.when(stepsToActions[stepCode].slice(0));
            }

            return rest
                .map("workflow", "steps", stepCode, "actions")
                .willReturn(actionType)
                .get()
                .then(function (actions) {
                    stepsToActions[stepCode] = actions.slice(0);
                    return actions;
                });
        };

        ///**
        // * Save action
        // * @param {string} stepCode
        // * @param {RepresentationModel} action Action Model or action id
        // * @returns {!Promise.<RepresentationModel>} promise of Action Model save
        // */
        // NOTE: this route is closed on server cause this is a security issue
        //_this.saveAction = function (stepCode, action) {
        //    return rest.map("workflow", "steps", stepCode, "actions").save(action);
        //};

        //endregion

        /**
         * Execute action for enumerated OrderItems
         * @param {string} stepCode step code
         * @param {string} actionCode action code
         * @param {string|number} orderItemId orderItem id
         * @returns {!Promise} promise of executing action result
         */
        _this.executeActionForOrderItem = function (stepCode, actionCode, orderItemId) {
            return rest
                .map("workflow", "steps", stepCode, "action", actionCode)
                .post(orderItemId)
                .then(function () {
                    // Order item is changed after step execution
                    // We need to update it
                    return rest
                        .map(rest.getDefinition("OrderItemModel"))
                        .map(orderItemId)
                        .willReturn("OrderItemModel")
                        .get();
                });
        };

        return _this;
    })

;